import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IHelpDialogData } from 'src/app/models';

@Component({
    selector: 'app-dialog-help',
    templateUrl: './dialog-help.component.html',
    styleUrls: ['./dialog-help.component.scss'],
    standalone: false
})
export class DialogHelpComponent {
  constructor(public dialogRef: MatDialogRef<DialogHelpComponent>, @Inject(MAT_DIALOG_DATA) public data: IHelpDialogData) { }
}
